import styled, { keyframes } from 'styled-components'
import { Popup } from 'react-map-gl'
import { ActiveMarker } from 'Components/MapBox'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import { _MapControl } from 'Components/SearchMap/components/MapControls/styles'


export const _MapWidthPopup = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  > div {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: auto;
  }
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    ${_MapControl} {
      width: 30px;
    }
    .zoomControl {
      bottom: 35px;
    }
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    .mapboxgl-ctrl-bottom-right {
      bottom: auto;
      top: 0;
    }
    .mapboxgl-ctrl-bottom-left {
      bottom: auto;
      top: 0;
      .mapboxgl-ctrl {
        margin: 10px 0 0 10px;
      }
    }
  }
`

const activePulse = keyframes`
  0% {
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2), 0 0 0 8px rgba(0, 0, 0, 0.2);
  }

`
export const _CurrentMarker = styled(ActiveMarker)`
  animation: ${activePulse} 1s infinite ease-out;
`

export const _Popup = styled(Popup)`
  transition: all 0.2s;
  display: flex!important;
  flex-direction: column-reverse!important;
  align-items: center;
  z-index: 100;
  .mapboxgl-popup-close-button {
    display: none;
  }
  .mapboxgl-popup-content {
    padding: 0;
    /*box-shadow: 9px 9px 13px -6px rgba(163,163,163,1);*/
    border: 1px solid #000;
    border-radius: 0;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      width: 8px;
      height: 8px;
      background-color: white;
      border-bottom: 1px solid #000;
      border-right: 1px solid #000;
      transform: rotate(45deg);
      bottom: -5px;
      left: calc(50% - 5px);
    }
  }
  ${({ currentPopup }) => (currentPopup && `
    .mapboxgl-popup-content {
      background-color: black;
      &:after {
        border: none;
        background-color: black;
      }
    }
  `)};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    margin: 0;
    top: auto!important;
    bottom: 15px!important;
    left: 50%!important;
    transform: translateX(-50%) !important;
    .mapboxgl-popup-content {
      &:after {
        display: none;
      }
    }
  }
`
